export default {
  SET_DATA_PRABAYAR (state, data) {
    state.prabayar = data
  }
}